import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IPaymentMethodSchemaPartial } from '../../type/paymentMethod';
import { ITranslationSubTypeInput } from '../../type/_inputTypes/translation';

export interface IUpdatePaymentMethodMutationFields {
  _id: string;
  name: ITranslationSubTypeInput[];
  description: ITranslationSubTypeInput[];
  status: boolean;
  paymentMethodType: string;
  company?: string;

  paymentChargeBy?: string;

  paymentApiKey?: string;
  paymentApiSecret?: string;
  paymentPayeeId?: string;

  paymentMode?: string;
  paymentClientId?: string;
  paymentClientSecret?: string;

  restrictionCountry?: string;
  restrictionCurrency?: string;
  restrictionMinAmount?: number;
  restrictionMaxAmount?: number;

  paymentChargeBuyerType?: string;
  paymentChargeBuyerFixed?: number;
  paymentChargeBuyerPercentage?: number;
  paymentChargeBuyerMinCharge?: number;
  paymentChargeBuyerMaxCharge?: number;
  paymentChargeSellerType?: string;
  paymentChargeSellerFixed?: number;
  paymentChargeSellerPercentage?: number;
  paymentChargeSellerMinCharge?: number;
  paymentChargeSellerMaxCharge?: number;

  keepitalPaymentChargeBuyerType?: string;
  keepitalPaymentChargeBuyerFixed?: number;
  keepitalPaymentChargeBuyerPercentage?: number;
  keepitalPaymentChargeBuyerMinCharge?: number;
  keepitalPaymentChargeBuyerMaxCharge?: number;
  keepitalPaymentChargeSellerType?: string;
  keepitalPaymentChargeSellerFixed?: number;
  keepitalPaymentChargeSellerPercentage?: number;
  keepitalPaymentChargeSellerMinCharge?: number;
  keepitalPaymentChargeSellerMaxCharge?: number;
}


export interface IUpdatePaymentMethodMutationResponseFields {
  updatedPaymentMethod: IPaymentMethodSchemaPartial;
}


export function updatePaymentMethodMutation(fragment: string): DocumentNode {
  return gql`
        mutation updatePaymentMethod (
        $_id: String!,
$name: [TranslationSubTypeInput]!,
$description: [TranslationSubTypeInput]!,
$status: Boolean!,
$paymentMethodType: String!,
$company: String,
$paymentMode: String,
$paymentApiKey : String,
$paymentApiSecret : String,
$paymentPayeeId : String,
$paymentClientId: String,
$paymentClientSecret: String,
$paymentChargeBy: String,
$restrictionCountry: String,
$restrictionCurrency: String,
$restrictionMinAmount: Float,
$restrictionMaxAmount: Float,
$paymentChargeBuyerType: String,
$paymentChargeBuyerFixed: Float,
$paymentChargeBuyerPercentage: Float,
$paymentChargeBuyerMinCharge: Float,
$paymentChargeBuyerMaxCharge: Float,
$paymentChargeSellerType: String,
$paymentChargeSellerFixed: Float,
$paymentChargeSellerPercentage: Float,
$paymentChargeSellerMinCharge: Float,
$paymentChargeSellerMaxCharge: Float,
$keepitalPaymentChargeBuyerType: String,
$keepitalPaymentChargeBuyerFixed: Float,
$keepitalPaymentChargeBuyerPercentage: Float,
$keepitalPaymentChargeBuyerMinCharge: Float,
$keepitalPaymentChargeBuyerMaxCharge: Float,
$keepitalPaymentChargeSellerType: String,
$keepitalPaymentChargeSellerFixed: Float,
$keepitalPaymentChargeSellerPercentage: Float,
$keepitalPaymentChargeSellerMinCharge: Float,
$keepitalPaymentChargeSellerMaxCharge: Float
        ) {
        updatePaymentMethod (
        _id: $_id,
name: $name,
description: $description,
status: $status,
paymentMethodType: $paymentMethodType,
company: $company,
paymentMode: $paymentMode,
paymentApiKey : $paymentApiKey ,
paymentApiSecret : $paymentApiSecret ,
paymentPayeeId : $paymentPayeeId ,
paymentClientId: $paymentClientId,
paymentClientSecret: $paymentClientSecret,
paymentChargeBy: $paymentChargeBy,
restrictionCountry: $restrictionCountry,
restrictionCurrency: $restrictionCurrency,
restrictionMinAmount: $restrictionMinAmount,
restrictionMaxAmount: $restrictionMaxAmount,
paymentChargeBuyerType: $paymentChargeBuyerType,
paymentChargeBuyerFixed: $paymentChargeBuyerFixed,
paymentChargeBuyerPercentage: $paymentChargeBuyerPercentage,
paymentChargeBuyerMinCharge: $paymentChargeBuyerMinCharge,
paymentChargeBuyerMaxCharge: $paymentChargeBuyerMaxCharge,
paymentChargeSellerType: $paymentChargeSellerType,
paymentChargeSellerFixed: $paymentChargeSellerFixed,
paymentChargeSellerPercentage: $paymentChargeSellerPercentage,
paymentChargeSellerMinCharge: $paymentChargeSellerMinCharge,
paymentChargeSellerMaxCharge: $paymentChargeSellerMaxCharge,
keepitalPaymentChargeBuyerType: $keepitalPaymentChargeBuyerType,
keepitalPaymentChargeBuyerFixed: $keepitalPaymentChargeBuyerFixed,
keepitalPaymentChargeBuyerPercentage: $keepitalPaymentChargeBuyerPercentage,
keepitalPaymentChargeBuyerMinCharge: $keepitalPaymentChargeBuyerMinCharge,
keepitalPaymentChargeBuyerMaxCharge: $keepitalPaymentChargeBuyerMaxCharge,
keepitalPaymentChargeSellerType: $keepitalPaymentChargeSellerType,
keepitalPaymentChargeSellerFixed: $keepitalPaymentChargeSellerFixed,
keepitalPaymentChargeSellerPercentage: $keepitalPaymentChargeSellerPercentage,
keepitalPaymentChargeSellerMinCharge: $keepitalPaymentChargeSellerMinCharge,
keepitalPaymentChargeSellerMaxCharge: $keepitalPaymentChargeSellerMaxCharge
        ) {
        ...fragment
        }
        }
        fragment fragment on UpdatePaymentMethodMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useUpdatePaymentMethodMutation<TData extends Partial<IUpdatePaymentMethodMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ updatePaymentMethod: TData },
        IUpdatePaymentMethodMutationFields>,
) {
  return useMutation<{ updatePaymentMethod: TData },
      IUpdatePaymentMethodMutationFields>(
        updatePaymentMethodMutation(fragment), options,
      );
}
